import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Engineeri8EnvironmentService } from './engineeri8-environment.service';
import {
  TREQUEST_ADD_NEW_FATIGUE_ALLOWANCES_MASTER,
  TREQUEST_ADD_NEW_MACHINE_MASTER,
  TREQUEST_ADD_NEW_OPERATION_MASTER,
  TREQUEST_ADD_NEW_PART_MASTER,
  TREQUEST_ADD_NEW_PRODUCT_TYPE_MASTER,
  TREQUEST_ADD_NEW_STYLE_MASTER,
  TREQUEST_FETCH_LIBRARY_METHODS,
  TRESPONSE_FETCH_LIBRARY_METHODS,
  TREQUEST_FETCH_LIBRARY_OBS,
  TRESPONSE_FETCH_LIBRARY_OBS,
  TREQUEST_SEARCH_FATIGUE_ALLOWANCE_MASTER,
  TREQUEST_UPDATE_BUNDLE_ALLOWANCE_MASTER,
  TRESPONSE_BUNDLE_ALLOWANCE_MASTER,
  TRESPONSE_FATIGUE_ALLOWANCE_MASTER,
  TRESPONSE_MACHINE_MASTER,
  TRESPONSE_OPERATION_MASTER,
  TRESPONSE_PART_MASTER,
  TRESPONSE_PRODUCT_TYPE_MASTER,
  TRESPONSE_STYLE_MASTER,
  TREQUEST_E8_MASTER_LISTING,
  TREQUEST_UPDATE_FATIGUE_ALLOWANCE_MASTER,
  TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS,
} from '@monorepo/types';

@Injectable({ providedIn: 'root' })
export class Engineeri8DataService {
  constructor(private http: HttpClient, private engineeri8EnvironmentService: Engineeri8EnvironmentService) {}

  addNewProductTypeMaster(payload: TREQUEST_ADD_NEW_PRODUCT_TYPE_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('ADD_NEW_PRODUCT_TYPE_MASTER');
    return this.http.post<void>(url, payload);
  }

  deleteProductTypeMaster(id: string) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('DELETE_PRODUCT_TYPE_MASTER').replace(':id', id);
    return this.http.post<void>(url, {});
  }

  addNewOperationMaster(payload: TREQUEST_ADD_NEW_OPERATION_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('ADD_NEW_OPERATION_MASTER');
    return this.http.post<void>(url, payload);
  }

  deleteOperationMaster(id: string) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('DELETE_OPERATION_MASTER').replace(':id', id);
    return this.http.post<void>(url, {});
  }

  addNewPartMaster(payload: TREQUEST_ADD_NEW_PART_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('ADD_NEW_PART_MASTER');
    return this.http.post<void>(url, payload);
  }

  deletePartMaster(id: string) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('DELETE_PART_MASTER').replace(':id', id);
    return this.http.post<void>(url, {});
  }

  addNewMachineMaster(payload: TREQUEST_ADD_NEW_MACHINE_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('ADD_NEW_MACHINE_MASTER');
    return this.http.post<void>(url, payload);
  }

  deleteMachineMaster(id: string) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('DELETE_MACHINE_MASTER').replace(':id', id);
    return this.http.post<void>(url, {});
  }

  addNewStyleMaster(payload: TREQUEST_ADD_NEW_STYLE_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('ADD_NEW_STYLE_MASTER');
    return this.http.post<void>(url, payload);
  }

  deleteStyleMaster(id: string) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('DELETE_STYLE_MASTER').replace(':id', id);
    return this.http.post<void>(url, {});
  }

  addNewFatigueAllowanceMaster(payload: TREQUEST_ADD_NEW_FATIGUE_ALLOWANCES_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('ADD_NEW_FATIGUE_ALLOWANCE_MASTER');
    return this.http.post<void>(url, payload);
  }

  searchProductTypeMaster(payload: TREQUEST_E8_MASTER_LISTING) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('SEARCH_PRODUCT_TYPE_MASTER');
    return this.http.post<TRESPONSE_PRODUCT_TYPE_MASTER>(url, payload);
  }

  searchOperationMaster(payload: TREQUEST_E8_MASTER_LISTING) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('SEARCH_OPERATION_MASTER');
    return this.http.post<TRESPONSE_OPERATION_MASTER>(url, payload);
  }

  searchPartMaster(payload: TREQUEST_E8_MASTER_LISTING) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('SEARCH_PART_MASTER');
    return this.http.post<TRESPONSE_PART_MASTER>(url, payload);
  }

  searchStyleMaster(payload: TREQUEST_E8_MASTER_LISTING) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('SEARCH_STYLE_MASTER');
    return this.http.post<TRESPONSE_STYLE_MASTER>(url, payload);
  }

  searchMachineMaster(payload: TREQUEST_E8_MASTER_LISTING) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('SEARCH_MACHINE_MASTER');
    return this.http.post<TRESPONSE_MACHINE_MASTER>(url, payload);
  }

  searchFatigueAllowanceMaster(payload: TREQUEST_SEARCH_FATIGUE_ALLOWANCE_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('SEARCH_FATIGUE_ALLOWANCE_MASTER');
    return this.http.post<TRESPONSE_FATIGUE_ALLOWANCE_MASTER>(url, payload);
  }

  deleteFatigueAllowanceMaster(id: string) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('DELETE_FATIGUE_ALLOWANCE_MASTER').replace(':id', id);
    return this.http.post<void>(url, {});
  }

  updateFatigueAllowanceMaster(payload: TREQUEST_UPDATE_FATIGUE_ALLOWANCE_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('UPDATE_FATIGUE_ALLOWANCE_MASTER');
    return this.http.post<void>(url, payload);
  }

  getBundleAllowance() {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('GET_BUNDLE_ALLOWANCE');
    return this.http.get<TRESPONSE_BUNDLE_ALLOWANCE_MASTER>(url);
  }

  updateBundleAllowance(payload: TREQUEST_UPDATE_BUNDLE_ALLOWANCE_MASTER) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('UPDATE_BUNDLE_ALLOWANCE');
    return this.http.post<void>(url, payload);
  }

  getAllProductTypes() {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('GET_ALL_PRODUCT_TYPES');
    return this.http.get<TRESPONSE_GET_ALL_PRODUCT_TYPE_OPTIONS>(url);
  }

  fetchAllMethods(payload: TREQUEST_FETCH_LIBRARY_METHODS) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('FETCH_ALL_METHODS');
    return this.http.post<TRESPONSE_FETCH_LIBRARY_METHODS>(url, payload);
  }

  fetchAllOBs(payload: TREQUEST_FETCH_LIBRARY_OBS) {
    const url = this.engineeri8EnvironmentService.getUrlFromEnv('FETCH_ALL_OPERATION_BREAKDOWNS');
    return this.http.post<TRESPONSE_FETCH_LIBRARY_OBS>(url, payload);
  }
}
